import { TranslateService } from '@ngx-translate/core';

import { AppComponent } from '../app.component';

export const RouterStates : Array<any> = [
  {
    component : AppComponent,
    name      : 'app',
    redirectTo: 'app.login',
    resolve   : [
      {
        deps     : [ TranslateService ],
        resolveFn: ( translate : TranslateService ) => translate.get('GENERAL_SPACE.BUTTON.OK').toPromise(),
        token    : 'translationsReady'
      },
    ],
    url: '?disconnect' }
];
